/**
* Customizer Library
* Permite manejar eventos del designmode
* Pre-requisitos: Los elementos deben tener su respectivo {{ block.shopify_attributes}}

* USO:
* Haciendola.customizer.subscribe(sectionElement); // Entiendase elemento como la sección
* sectionElement.customizerEvent("select", callback); // "select" es el evento a escuchar. Callback es lo que sucederá cuando se dispare el evento
* bloque.customizerEvent("select", callback); // "select" es el evento del bloque. Callback será lo que se ejecuta cuando suceda.

* NOTA PARA LIQUID:
- Los imports deben hacerse por funciones, no por sentencia import
  - Mal EJ:
    import Swiper from 'swiper.js'

  - Buen EJ:
    const {Swiper} = await import('swiper.js')

*/

class CustomizerClass {
  constructor() {
    this.sections = {}
    this._queue = {}
    this._await = {}

    this.initListeners()
  }

  initListeners() {
    if (!Shopify.designMode) return

    document.addEventListener('shopify:section:load', ({ detail, target }) => {
      const scripts = target.querySelectorAll('script')
      scripts.forEach(sc => {
        const src = sc.getAttribute('src')
        if (!src) {
          eval(sc.textContent)
          return
        }
        fetch(sc.src)
          .then(src => src.text())
          .then(code => eval(code))
      })

      if (this._queue[detail.sectionId]) this._queue[detail.sectionId]()

      const section = this.sections[detail.sectionId]
      if (!section) return

      const listeners = section._events['load']
      if (listeners)
        listeners.forEach(callback =>
          callback({ detail, target, subscriber: section.element })
        )
      // delete this.sections[detail.sectionId]
    })

    document.addEventListener(
      'shopify:section:unload',
      ({ detail, target }) => {
        const section = this.sections[detail.sectionId]
        if (!section) return
        const listeners = section._events['unload']
        if (listeners)
          listeners.forEach(callback =>
            callback({ detail, target, subscriber: section.element })
          )
      }
    )

    document.addEventListener(
      'shopify:section:select',
      ({ detail, target }) => {
        const section = this.sections[detail.sectionId]
        if (!section) return
        const listeners = section._events['select']
        if (listeners)
          listeners.forEach(callback =>
            callback({ detail, target, subscriber: section.element })
          )
      }
    )

    document.addEventListener(
      'shopify:section:deselect',
      ({ detail, target }) => {
        const section = this.sections[detail.sectionId]
        if (!section) return
        const listeners = section._events['deselect']
        if (listeners)
          listeners.forEach(callback =>
            callback({ detail, target, subscriber: section.element })
          )
      }
    )

    document.addEventListener(
      'shopify:section:reorder',
      ({ detail, target }) => {
        const section = this.sections[detail.sectionId]
        if (!section) return
        const listeners = section._events['reorder']
        if (listeners)
          listeners.forEach(callback =>
            callback({ detail, target, subscriber: section.element })
          )
      }
    )

    document.addEventListener('shopify:block:select', ({ detail, target }) => {
      const section = this.sections[detail.sectionId]
      if (!section) return
      const listeners = section._blockEvents[detail.blockId]['select']
      if (listeners)
        listeners.forEach(callback =>
          callback({ detail, target, subscriber: section.element })
        )
    })

    document.addEventListener(
      'shopify:block:deselect',
      ({ detail, target }) => {
        const section = this.sections[detail.sectionId]
        if (!section) return
        const listeners = section._blockEvents[detail.blockId]['deselect']
        if (listeners)
          listeners.forEach(callback =>
            callback({ detail, target, subscriber: section.element })
          )
      }
    )
  }

  getAttributes(element) {
    if (!Shopify.designMode) return
    const block = element.getAttribute('data-shopify-editor-block')
    if (block) return { ...JSON.parse(block), itemType: 'block' }
    const section = element.closest(`[data-shopify-editor-section]`)
    if (!section) return {}
    const sectionData = section.getAttribute('data-shopify-editor-section')
    return { ...JSON.parse(sectionData), itemType: 'section' }
  }

  prepare({ section, element }) {
    const blocks = [...element.querySelectorAll('[data-shopify-editor-block]')]
    const sectionTree = {
      blocks,
      element,
      _blockEvents: {},
      _events: {},
    }
    blocks.forEach(block => {
      const data = Haciendola.customizer.getAttributes(block)
      block.dataset.designer_section_parent = section.id
      sectionTree._blockEvents[data.id] = {}
    })

    this._await[section.id] = new Promise(s => {
      const resolve = () => {
        delete Haciendola.customizer.sections[section.id]
        Haciendola.customizer.sections[section.id] = sectionTree
        s()
      }

      if (!this.sections[section.id]) return resolve()

      this._queue[section.id] = resolve
    })
  }

  subscribe(element) {
    if (!Shopify.designMode) return
    const section = this.getAttributes(element)
    if (section.itemType !== 'section')
      return console.error('El elemento no es una sección')

    this.prepare({ section, element })
  }
}

Haciendola.registerLibrary('customizer', new CustomizerClass())

Element.prototype.customizerEvent = async function (event, callback) {
  if (!Shopify.designMode) return

  const item = Haciendola.customizer.getAttributes(this)

  switch (item.itemType) {
    case 'block':
      const sectionID = this.dataset.designer_section_parent
      if (!sectionID) return
      await Haciendola.customizer._await[sectionID]

      let events =
        Haciendola.customizer.sections[sectionID]._blockEvents[item.id][event]
      if (!events)
        Haciendola.customizer.sections[sectionID]._blockEvents[item.id][event] =
          []
      Haciendola.customizer.sections[sectionID]._blockEvents[item.id][
        event
      ].push(callback)
      break

    case 'section':
      if (Haciendola.customizer._await[item.id])
        await Haciendola.customizer._await[item.id]
      const eventsSection =
        Haciendola.customizer.sections[item.id]?._events[event]
      if (!eventsSection)
        Haciendola.customizer.sections[item.id]._events[event] = []
      Haciendola.customizer.sections[item.id]?._events[event].push(callback)
  }
}
